var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"h4 text-bold m-b-2",attrs:{"selenium":"rsf-thanks-text"}},[_c('p',[_vm._v("Thanks "+_vm._s(_vm.name)+"!")]),_c('p',[_vm._v("We've received your service request.")])]),_c('p',{staticClass:"c-gray70 h6"},[_vm._v("An email confirmation has been sent.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }